export const TAG_LOCALE_ZHCHS = {
    addText: 'æ·»å ',
    placeholder: 'è¯·è¾å¥'
};
